import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFolderCubeInterpretationSizeS from './IconFolderCubeInterpretation_size_s';

const props: CreateIconArguments = {
  l: IconFolderCubeInterpretationSizeS,
  m: IconFolderCubeInterpretationSizeS,
  s: IconFolderCubeInterpretationSizeS,
  xs: IconFolderCubeInterpretationSizeS,
  name: 'IconFolderCubeInterpretation',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
